import { useParams } from 'react-router-dom'

import { CompanyRouteParams } from '..'

export function useCompanyParameter() {
  const {company} = useParams<CompanyRouteParams>();

  return company as string;
}
